import { Component, EventEmitter, Input, Output } from "@angular/core";
import { FormControl } from "@angular/forms";

import { SearchFilterOptionModel } from "../../models/search-filter-option.model";

@Component({
    selector: "[pcg-ng-search-filter]",
    templateUrl: "./search-filter.component.html",
    providers: []
})
export class SearchFilterComponent {

    @Input()
    public label: string = null;

    public control: FormControl<Array<string>> = null;
    @Input("control")
    public set controlSetter(value: FormControl<Array<string>>) {
        this.control = value;
    }

    public options: Array<SearchFilterOptionModel> = [];
    @Input("options")
    public set optionsSetter(value: Array<SearchFilterOptionModel>) {
        this.options = value || [];
    }

    @Output()
    public onSelect = new EventEmitter();

    public onToggle(option: SearchFilterOptionModel): void {
        if (option.selected) {
            this.control.value.push(option.name);
        } else {
            this.control.value.splice(this.control.value.indexOf(option.name), 1);
        }

        this.onSelect.emit();
    }
}
